(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpc-form-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    const MIN_FILL_MS = 3000;
    const MAX_URLS = 2;
    const RELEASE_MS = 10000;
    const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"']+|\b[a-z0-9-]+(?:\.[a-z0-9-]+)*\.(?:com|net|org|info|biz|io|co|us|ru|cn|xyz|top|site|online|shop|store|click|link|live|club|pro|app|dev)\b(?:\/[^\s<>"']*)?/gi;
    const ownHost = window.location.hostname.replace(/^www\./, '');

    const externalUrls = (text) =>
      (text.match(URL_RE) || []).filter((url) => !url.toLowerCase().includes(ownHost));

    const onlyLinks = (text) => {
      const matches = text.match(URL_RE);
      if (!matches) return false;
      return text.replace(URL_RE, '').replace(/[\s.,;:!?()\-–—"'/]+/g, '') === '';
    };

    const init = (form) => {
      if (form.dataset.tpcGuardReady) return;
      form.dataset.tpcGuardReady = 'true';
      form.setAttribute('novalidate', '');
      let startedAt = Date.now();
      const errorBox = form.querySelector('[data-tpc-guard-error]');
      const submitButton = form.querySelector('[type="submit"]');
      let releaseTimer;

      const clearErrors = () => {
        errorBox.hidden = true;
        errorBox.textContent = '';
        form.querySelectorAll('[data-tpc-invalid]').forEach((field) => {
          field.removeAttribute('aria-invalid');
          field.removeAttribute('data-tpc-invalid');
          const describedBy = (field.getAttribute('aria-describedby') || '')
            .split(' ')
            .filter((id) => id && id !== errorBox.id)
            .join(' ');
          if (describedBy) field.setAttribute('aria-describedby', describedBy);
          else field.removeAttribute('aria-describedby');
        });
      };

      const fail = (event, messageKey, field) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        errorBox.textContent = errorBox.dataset[messageKey];
        errorBox.hidden = false;
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('data-tpc-invalid', '');
          const describedBy = (field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
          if (!describedBy.includes(errorBox.id)) describedBy.push(errorBox.id);
          field.setAttribute('aria-describedby', describedBy.join(' '));
          field.focus();
        } else {
          errorBox.setAttribute('tabindex', '-1');
          errorBox.focus();
        }
      };

      const release = () => {
        clearTimeout(releaseTimer);
        if (!submitButton) return;
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      };

      form.addEventListener(
        'submit',
        (event) => {
          clearErrors();

          const honeypot = form.querySelector('[data-tpc-honeypot]');
          if (honeypot && honeypot.value.trim() !== '') return fail(event, 'msgBlocked');

          const message = form.querySelector('[data-tpc-message]');
          const requiredFields = Array.from(form.querySelectorAll('[required]')).filter(
            (field) => !field.closest('.tpc-hp') && !field.hasAttribute('data-tpc-message')
          );
          for (const field of requiredFields) {
            const invalid =
              field.value.trim() === '' || (field.type === 'email' && !field.checkValidity());
            if (invalid) return fail(event, 'msgRequired', field);
          }

          if (message && message.value.trim() === '') return fail(event, 'msgEmpty', message);


          for (const field of form.querySelectorAll('[data-tpc-text]')) {
            const text = field.value.trim();
            if (!text) continue;
            if (onlyLinks(text)) return fail(event, 'msgLinksOnly', field);
            if (externalUrls(text).length > MAX_URLS) return fail(event, 'msgTooManyLinks', field);
          }

          if (Date.now() - startedAt < MIN_FILL_MS) return fail(event, 'msgTooFast');

          if (submitButton) {
            submitButton.setAttribute('aria-busy', 'true');
            setTimeout(() => {
              submitButton.disabled = true;
            }, 0);
            releaseTimer = setTimeout(release, RELEASE_MS);
          }
        },
        true
      );

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          startedAt = Date.now();
          release();
        }
      });
    };

    const initAll = () => document.querySelectorAll('form[data-tpc-guard]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpc-product-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tpc-copy-button')) {
    customElements.define(
      'tpc-copy-button',
      class TpcCopyButton extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.status = this.querySelector('[role="status"]');
          this.button?.addEventListener('click', () => this.copy());
        }

        async copy() {
          const target = document.getElementById(this.dataset.copyTarget);
          if (!target) return;
          const value = target.textContent.trim();
          try {
            await navigator.clipboard.writeText(value);
          } catch (error) {
            const range = document.createRange();
            range.selectNodeContents(target);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            return;
          }
          const label = this.button.querySelector('.tpc-copy__text');
          const original = label.textContent;
          label.textContent = this.button.dataset.copiedLabel;
          this.status.textContent = `${this.button.dataset.copiedLabel}: ${value}`;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            label.textContent = original;
            this.status.textContent = '';
          }, 2000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpc-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tpc-sticky-atc')) {
    customElements.define(
      'tpc-sticky-atc',
      class TpcStickyAtc extends HTMLElement {
        connectedCallback() {
          const form = document.getElementById(this.dataset.formId);
          this.mainButton = form?.querySelector('[type="submit"][name="add"]');
          if (!this.mainButton) return;
          this.hidden = false;
          this.mq = window.matchMedia('(max-width: 749px)');
          this.ticking = false;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              this.update();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }

        update() {
          const passed = this.mainButton.getBoundingClientRect().bottom < 0;
          const show = passed && this.mq.matches && !this.mainButton.disabled;
          this.classList.toggle('is-visible', show);
          document.body.classList.toggle('tpc-has-sticky-atc', show);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
